import {
  BarChart3, LineChart, AreaChart, PieChart, Donut, ScatterChart, Grid3x3,
  Radar, Filter as FunnelIcon, Gauge, TrendingUp, Table2, Type, Image as ImageIcon,
  SlidersHorizontal, Activity, LayoutGrid, Map, MapPin, Sun, Share2, CandlestickChart,
  Network, Cloud, Droplet, Box, Boxes, Calendar, AlignVerticalJustifyEnd, ArrowLeftRight, Rows3,
  ChevronDownSquare, List, CalendarRange, GitCompareArrows,
} from "lucide-react";
import { dimOutNames } from "@/lib/dimKeys";

// Catalog of all widgets available in the builder library.
export const WIDGET_CATALOG = [
  { type: "kpi", label: "KPI Card", icon: TrendingUp, group: "Stats", needs: { dims: 0, measures: 1 } },
  { type: "scenario_grid", label: "Scenario Compare", icon: GitCompareArrows, group: "Stats", needs: { dims: 0, measures: 1 } },
  { type: "gauge", label: "Radial Gauge", icon: Gauge, group: "Stats", needs: { dims: 0, measures: 1 } },
  { type: "liquidfill", label: "Liquid Fill", icon: Droplet, group: "Stats", needs: { dims: 0, measures: 1 } },
  { type: "bar", label: "Bar / Column", icon: BarChart3, group: "Charts", needs: { dims: 1, measures: 1 } },
  { type: "bar_stacked", label: "Stacked Bar", icon: LayoutGrid, group: "Charts", needs: { dims: 1, measures: 1 } },
  { type: "line", label: "Line", icon: LineChart, group: "Charts", needs: { dims: 1, measures: 1 } },
  { type: "area", label: "Area", icon: AreaChart, group: "Charts", needs: { dims: 1, measures: 1 } },
  { type: "combo", label: "Combo (Bar+Line)", icon: Activity, group: "Charts", needs: { dims: 1, measures: 2 } },
  { type: "pie", label: "Pie", icon: PieChart, group: "Charts", needs: { dims: 1, measures: 1 } },
  { type: "donut", label: "Donut", icon: Donut, group: "Charts", needs: { dims: 1, measures: 1 } },
  { type: "scatter", label: "Scatter", icon: ScatterChart, group: "Charts", needs: { dims: 1, measures: 2 } },
  { type: "heatmap", label: "Heatmap", icon: Grid3x3, group: "Charts", needs: { dims: 2, measures: 1 } },
  { type: "treemap", label: "Treemap", icon: LayoutGrid, group: "Charts", needs: { dims: 1, measures: 1 } },
  { type: "radar", label: "Radar", icon: Radar, group: "Charts", needs: { dims: 1, measures: 1 } },
  { type: "funnel", label: "Funnel", icon: FunnelIcon, group: "Charts", needs: { dims: 1, measures: 1 } },
  { type: "tornado", label: "Tornado", icon: ArrowLeftRight, group: "Charts", needs: { dims: 1, measures: 2 } },
  // Advanced & relationship charts
  { type: "sunburst", label: "Sunburst", icon: Sun, group: "Advanced", needs: { dims: 2, measures: 1 } },
  { type: "sankey", label: "Sankey Flow", icon: Share2, group: "Advanced", needs: { dims: 2, measures: 1 } },
  { type: "graph", label: "Network Graph", icon: Network, group: "Advanced", needs: { dims: 2, measures: 1 } },
  { type: "candlestick", label: "Candlestick", icon: CandlestickChart, group: "Advanced", needs: { dims: 1, measures: 4 } },
  { type: "wordcloud", label: "Word Cloud", icon: Cloud, group: "Advanced", needs: { dims: 1, measures: 1 } },
  { type: "waterfall", label: "Waterfall", icon: AlignVerticalJustifyEnd, group: "Advanced", needs: { dims: 1, measures: 1 } },
  { type: "boxplot", label: "Box Plot", icon: Box, group: "Advanced", needs: { dims: 1, measures: 1 } },
  { type: "calendar_heatmap", label: "Calendar Heatmap", icon: Calendar, group: "Advanced", needs: { dims: 1, measures: 1 } },
  // 3D
  { type: "bar_3d", label: "3D Bars", icon: Boxes, group: "3D", needs: { dims: 2, measures: 1 } },
  { type: "scatter_3d", label: "3D Scatter", icon: Box, group: "3D", needs: { dims: 1, measures: 3 } },
  // Image-in-chart
  { type: "pictorial_bar", label: "Pictogram Bar", icon: ImageIcon, group: "Image", needs: { dims: 1, measures: 1 } },
  { type: "image_scatter", label: "Image Scatter", icon: ImageIcon, group: "Image", needs: { dims: 1, measures: 2 } },
  // Maps
  { type: "geo_map", label: "Map (Choropleth)", icon: Map, group: "Maps", needs: { dims: 1, measures: 1 } },
  { type: "bubble_map", label: "Bubble Map", icon: MapPin, group: "Maps", needs: { dims: 1, measures: 1 } },
  { type: "point_map", label: "Point Map (Lat/Long)", icon: MapPin, group: "Maps", needs: { dims: 0, measures: 0 } },
  { type: "google_map", label: "Google Map", icon: Map, group: "Maps", needs: { dims: 0, measures: 0 } },
  { type: "table", label: "Data Table", icon: Table2, group: "Data", needs: { dims: 1, measures: 0 } },
  { type: "data_grid", label: "Data Grid", icon: Rows3, group: "Data", needs: { dims: 0, measures: 0 } },
  { type: "pivot", label: "Pivot Table", icon: Grid3x3, group: "Data", needs: { dims: 2, measures: 1 } },
  { type: "perspective", label: "Perspective (Pivot/Chart)", icon: LayoutGrid, group: "Data", needs: { dims: 0, measures: 0 } },
  { type: "container", label: "Container (Combine)", icon: Boxes, group: "Layout", needs: { dims: 0, measures: 0 } },
  { type: "text", label: "Text / Note", icon: Type, group: "Layout", needs: { dims: 0, measures: 0 } },
  { type: "image", label: "Image", icon: ImageIcon, group: "Layout", needs: { dims: 0, measures: 0 } },
  { type: "slicer", label: "Filter / Slicer", icon: SlidersHorizontal, group: "Layout", needs: { dims: 1, measures: 0 } },
  { type: "combo_box", label: "Combo Box Filter", icon: ChevronDownSquare, group: "Layout", needs: { dims: 1, measures: 0 } },
  { type: "list_box", label: "List Box Filter", icon: List, group: "Layout", needs: { dims: 1, measures: 0 } },
  { type: "date_picker", label: "Date Filter", icon: CalendarRange, group: "Layout", needs: { dims: 1, measures: 0 } },
  { type: "multi_filter", label: "Multi Filter", icon: SlidersHorizontal, group: "Layout", needs: { dims: 0, measures: 0 } },
];

export const GEO_TYPES = ["geo_map", "bubble_map"];

// Widgets that require ECharts extensions (echarts-gl / wordcloud / liquidfill).
// These are lazy-loaded on demand to keep the base bundle small.
export const GL_TYPES = ["bar_3d", "scatter_3d"];
export const EXT_TYPES = ["bar_3d", "scatter_3d", "wordcloud", "liquidfill"];
// Extension-provided series that must be rendered with the canvas renderer.
export const CANVAS_TYPES = ["bar_3d", "scatter_3d", "wordcloud", "liquidfill"];

// Widget types that need 2 dimensions to render meaningfully (source/target or hierarchy).
export const DUAL_DIM_TYPES = ["heatmap", "sunburst", "sankey", "graph", "bar_3d", "pivot"];

// Widget types that support image-symbol / background-image styling.
export const IMAGE_TYPES = ["pictorial_bar", "image_scatter", "scatter", "bubble_map"];

// Widget types that support click-to-drilldown into a deeper dimension.
export const DRILLDOWN_TYPES = ["bar", "bar_stacked", "line", "area", "combo", "pie", "donut", "treemap", "funnel", "geo_map", "bubble_map"];

// Scope active global filters to a given widget's dataset.
export function applicableFilters(widget, activeFilters = []) {
  // A cross-source SQL widget has no single dataset: the engine matches each filter to the
  // subquery that owns it and resolves {{where:…}} tokens, so hand it everything (with ids).
  if (widget?.federated_spec?.combine_sql) {
    return (activeFilters || []).map(({ __src, __scope, ...rest }) => rest);
  }
  return (activeFilters || [])
    .filter((f) => !f.dataset_id || f.dataset_id === widget.dataset_id)
    .map(({ dataset_id, __src, ...rest }) => rest);
}

// Widget types that can render "highlight" mode: non-matching data is DIMMED
// (opacity reduced) instead of filtered out (items 168 + cross-highlight).
export const HIGHLIGHT_TYPES = ["bar", "bar_stacked", "line", "area", "combo", "pie", "donut", "funnel", "scatter", "tornado", "pictorial_bar"];

// Split active filters for a widget into {query, highlight}: cross-filters emitted by
// other widgets become highlights when this widget opts into cross_receive="highlight".
// Item 195.9: does a filter's widget scope allow this widget?
export function scopeAllows(scope, widgetId) {
  if (!scope || scope.mode === "all" || !Array.isArray(scope.ids)) return true;
  const inList = scope.ids.includes(widgetId);
  return scope.mode === "include" ? inList : !inList;
}

// ---------------------------------------------------------------------------
// Interaction engine (items 12/15). A filter emitted by a MASTER widget (slicer, filter
// widget, chart cross-filter) reaches a LISTENER widget only when:
//   1. the master's interaction matrix does not mark the listener "none", and
//   2. the master's field can be mapped onto the listener's dataset:
//        a. explicit mapping for that listener widget           (field_mappings.target_widget)
//        b. explicit mapping for the listener's dataset          (field_mappings.target_dataset)
//        c. same dataset                                         (same field)
//        d. default "match by name": listener dataset has a column with the same name
//      Anything else is DROPPED for that listener — never silently applied globally.
// ---------------------------------------------------------------------------
export const MASTER_FILTER_TYPES = ["slicer", "multi_filter", "combo_box", "list_box", "date_picker"];

function datasetFieldNames(datasets, dsId) {
  if (!datasets || !dsId) return null;
  if (Array.isArray(datasets)) {
    const d = datasets.find((x) => x.id === dsId);
    if (!d) return null;
    return new Set([...(d.schema || []).map((c) => c.name), ...(d.calc_fields || []).map((c) => c.name)]);
  }
  const names = datasets[dsId];  // Viewer: {dataset_id: [field names]}
  return Array.isArray(names) ? new Set(names) : null;
}

// Resolve how a master's filter field maps onto a listener. Returns
// {ok, via: "widget"|"dataset"|"same"|"name"|"none", field, reason}.
export function resolveListenerMapping(src, targetWidget, field, datasets = null) {
  if (!src || !targetWidget || !field) return { ok: false, via: "none", reason: "missing field" };
  const maps = (src.config?.field_mappings || []).filter((m) => m.source_col === field && m.target_col);
  const byWidget = maps.find((m) => m.target_widget && m.target_widget === targetWidget.id);
  if (byWidget) return { ok: true, via: "widget", field: byWidget.target_col };
  const byDs = maps.find((m) => !m.target_widget && m.target_dataset === targetWidget.dataset_id);
  if (byDs) return { ok: true, via: "dataset", field: byDs.target_col };
  if (src.dataset_id === targetWidget.dataset_id) return { ok: true, via: "same", field };
  const names = datasetFieldNames(datasets, targetWidget.dataset_id);
  if (names === null) return { ok: false, via: "none", reason: "target dataset fields unknown" };
  if (names.has(field)) return { ok: true, via: "name", field };
  const lower = field.toLowerCase();
  const ci = [...names].find((n) => n.toLowerCase() === lower);
  if (ci) return { ok: true, via: "name", field: ci };
  return { ok: false, via: "none", reason: `no column “${field}” in the listener's dataset — set a target column` };
}

function mapCrossSource(f, src, targetWidget, datasets) {
  if (!src || !f.field) return f;
  const r = resolveListenerMapping(src, targetWidget, f.field, datasets);
  if (!r.ok) return null;
  return r.field === f.field && src.dataset_id === targetWidget.dataset_id ? f : { ...f, field: r.field, dataset_id: targetWidget.dataset_id };
}

// Slicer / multi-filter selections live in a `${dataset_id}::${field}` map (bookmarks depend
// on that shape). Attach the owning master widget id (__src) so the matrix can gate them.
export function slicerFilters(slicerVals, widgets = []) {
  const out = [];
  Object.entries(slicerVals || {}).forEach(([key, value]) => {
    if (value == null || value === "" || (Array.isArray(value) && !value.length)) return;
    const [dataset_id, field] = key.split("::");
    // Item 4: a slicer value may carry an exclude flag — {v: [...], exclude: true} → NOT IN.
    const obj = !Array.isArray(value) && typeof value === "object" ? value : null;
    if (obj && !(obj.v || []).length) return;
    const base = obj
      ? { dataset_id, field, op: obj.exclude ? "not_in" : "in", value: obj.v }
      : Array.isArray(value) ? { dataset_id, field, op: "in", value } : { dataset_id, field, op: "eq", value };
    const owners = (widgets || []).filter((w) => w.dataset_id === dataset_id && !w.hidden && (
      (w.type === "slicer" && w.config?.dimensions?.[0]?.field === field) ||
      (w.type === "multi_filter" && (w.config?.fields || []).some((x) => x && x.field === field))));
    if (!owners.length) out.push(base);
    else owners.forEach((w) => out.push({ ...base, __src: w.id }));
  });
  return out;
}

export function splitInteractionFilters(widget, activeFilters = [], allWidgets = [], datasets = null, keepForeign = false) {
  const byId = {};
  (allWidgets || []).forEach((w) => { byId[w.id] = w; });
  const canHl = HIGHLIGHT_TYPES.includes(widget.type);
  const fed = !!(widget?.federated_spec?.combine_sql);
  const wantHighlight = widget.config?.cross_receive === "highlight" && canHl;
  const query = [], highlight = [];
  (activeFilters || []).forEach((f) => {
    if (f.__scope && !scopeAllows(f.__scope, widget.id)) return;
    let pairMode;
    if (f.__src) {
      if (f.__src === widget.id) return;
      const src = byId[f.__src];
      pairMode = src?.config?.interactions?.[widget.id];
      if (pairMode === "none") return;
      if (src) {
        f = mapCrossSource(f, src, widget, datasets);
        if (!f) return;
      }
    }
    if (fed) {
      const { __src: _fs, __scope: _fsc, ...all } = f;   // keep dataset_id + filter_id for the SQL engine
      query.push(all);
      return;
    }
    if (f.dataset_id && f.dataset_id !== widget.dataset_id) {
      if (!keepForeign) return;
      const { __src: _s, __scope: _sc, ...foreign } = f;   // keep dataset_id so the join can reach it
      query.push(foreign);
      return;
    }
    const { dataset_id, __src, __scope, ...rest } = f;
    if (__src && (wantHighlight || (pairMode === "highlight" && canHl))) highlight.push(rest);
    else query.push(rest);
  });
  return { query, highlight };
}

// Like applicableFilters, but honours the per-widget interaction matrix.
export function interactionFilters(widget, activeFilters = [], allWidgets = [], datasets = null) {
  const byId = {};
  (allWidgets || []).forEach((w) => { byId[w.id] = w; });
  const list = [];
  (activeFilters || []).forEach((f) => {
    if (f.__scope && !scopeAllows(f.__scope, widget.id)) return;
    if (f.__src) {
      if (f.__src === widget.id) return;
      const src = byId[f.__src];
      if (src?.config?.interactions?.[widget.id] === "none") return;
      if (src) { f = mapCrossSource(f, src, widget, datasets); if (!f) return; }
    }
    const { __scope, ...rest } = f;
    list.push(rest);
  });
  return applicableFilters(widget, list);
}

export const AGG_OPTIONS = [
  { value: "sum", label: "Sum" },
  { value: "avg", label: "Average" },
  { value: "count", label: "Count" },
  { value: "count_distinct", label: "Distinct Count" },
  { value: "counta", label: "Count Non-Empty" },
  { value: "min", label: "Min" },
  { value: "max", label: "Max" },
  { value: "median", label: "Median" },
  { value: "product", label: "Product" },
  { value: "stddev", label: "Std Dev" },
  { value: "stddevp", label: "Std Dev (pop.)" },
  { value: "var", label: "Variance" },
  { value: "varp", label: "Variance (pop.)" },
];

// Item 35: the date hierarchy. "Bare" levels collapse the year (Quarter = Q1..Q4,
// Month = Jan..Dec); the "… year" levels are absolute periods (Q1 2025, Jan 2025, W01 2025).
// `quarter`/`month`/`week_number` keep their legacy ids so saved dashboards are untouched.
export const DATE_PARTS = [
  { value: "none", label: "As-is" },
  { value: "year", label: "Year" },
  { value: "quarter_of_year", label: "Quarter" },
  { value: "month_of_year", label: "Month" },
  { value: "week", label: "Week" },
  { value: "day", label: "Day" },
  { value: "quarter", label: "Quarter year" },
  { value: "month", label: "Month year" },
  { value: "week_year", label: "Week year" },
  { value: "day_of_week", label: "Day of week" },
  { value: "week_of_year", label: "Week of year" },
  { value: "date_hour", label: "Date hour" },
  // Item 20: fiscal calendar (year start month + week numbering come from regional settings)
  { value: "fiscal_year", label: "Fiscal year" },
  { value: "fiscal_quarter", label: "Fiscal quarter" },
  { value: "fiscal_month", label: "Fiscal period" },
];

// Legacy ids that now live under a clearer name (same values from the engine).
const DATE_PART_ALIASES = { week_number: "week_year" };
export const normalizeDatePart = (p) => DATE_PART_ALIASES[p] || p || "none";
export const datePartLabel = (p) => (DATE_PARTS.find((x) => x.value === normalizeDatePart(p)) || {}).label || "";

export function getWidgetMeta(type) {
  return WIDGET_CATALOG.find((w) => w.type === type) || WIDGET_CATALOG[0];
}

// Every dataset a widget touches: its binding + any cross-dataset field entries.
export function widgetDatasetIds(w) {
  const ids = new Set();
  if (w.dataset_id) ids.add(w.dataset_id);
  const cfg = w.config || {};
  [...(cfg.dimensions || []), ...(cfg.measures || [])].forEach((e) => { if (e && e.dataset_id) ids.add(e.dataset_id); });
  return [...ids];
}

// True when any dim/measure comes from a dataset other than the widget's binding —
// such widgets query through the relationship-joined model engine.
export function isCrossDatasetWidget(w) {
  const cfg = w.config || {};
  return [...(cfg.dimensions || []), ...(cfg.measures || []), ...(cfg.filters || [])]
    .some((e) => e && e.dataset_id && e.dataset_id !== w.dataset_id);
}

// Build a ModelQueryRequest (POST /api/model-query) from a cross-dataset widget config.
export function buildModelQuery(config, primaryDatasetId, globalFilters = []) {
  const dimensions = (config.dimensions || []).filter((d) => d && d.field).map((d) => ({
    dataset_id: d.dataset_id || primaryDatasetId, field: d.field,
    date_part: d.date_part && d.date_part !== "none" ? d.date_part : null, label: d.label || null,
  }));
  const measures = (config.measures || []).filter((m) => m && m.field).map((m) => ({
    dataset_id: m.dataset_id || primaryDatasetId, field: m.field, agg: m.agg || "sum", label: m.label || null,
  }));
  const filters = [...(config.filters || []), ...(globalFilters || [])]
    .filter((f) => f && f.field && f.value != null && f.value !== "" && !(Array.isArray(f.value) && !f.value.length))
    .map((f) => ({
      dataset_id: f.dataset_id || null, field: f.field, op: f.op || "in", value: f.value,
      ...(f.date_part && f.date_part !== "none" ? { date_part: f.date_part } : {}),
    }));
  const sort = (config.sort || []).map((s) => ({ key: s.key || s.field, direction: s.direction || "desc" }));
  return { dimensions, measures, filters, sort, limit: config.limit || 1000 };
}

// Build a QuerySpec from a widget config, merging dashboard-level global filters.
export function buildSpec(config, globalFilters = []) {
  const dims = (config.dimensions || []).map((d) => ({
    field: d.field,
    date_part: d.date_part && d.date_part !== "none" ? d.date_part : null,
  }));
  const measures = (config.measures || []).map((m) => ({ field: m.field, agg: m.agg || "sum", alias: m.alias || null }));
  const filters = [...(config.filters || []), ...(globalFilters || [])];
  return {
    dimensions: dims,
    measures,
    filters,
    sort: config.sort || [],
    limit: config.limit || 1000,
  };
}

// Build a governed SemanticQuery from a widget config (routes through the semantic engine).
// A dimension/measure with a `key` is treated as governed (resolved via the semantic model);
// otherwise it falls back to an ad-hoc {field, agg}/{field, date_part} reference. This keeps
// every widget (including advanced ones and AI-generated ones) on the governed query path.
export function buildSemanticQuery(config, globalFilters = []) {
  const post_bands = [];
  const dimObjs = (config.dimensions || []).filter((d) => d && (d.key || d.field || d.band));
  // Item 35: the same date field may be assigned twice with different hierarchy levels —
  // each instance gets its own output column so the two levels stay independent.
  const outNames = dimOutNames(dimObjs);
  const dimensions = dimObjs
    .map((d, i) => {
      // Items 28-30: measure bands become post-aggregation band columns, not group-bys.
      if (d.band && d.band.measure) {
        post_bands.push({
          measure: d.band.measure,
          breaks: (d.band.breaks || []).map(Number).filter(Number.isFinite),
          labels: d.band.labels || [],
          alias: d.alias || `${d.band.measure}_band`,
          label: d.label || null,
        });
        return null;
      }
      const date_part = d.date_part && d.date_part !== "none" ? d.date_part : null;
      const label = d.label || null;
      const bin = d.bin && (d.bin.size || (d.bin.breaks || []).length) ? d.bin : null;
      const out = outNames[i];
      return d.key
        ? { key: d.key, date_part, label, ...(out && out !== d.key ? { alias: out } : {}), ...(bin ? { bin } : {}) }
        : { field: d.field, date_part, label, ...(bin ? { bin, alias: d.alias || null } : {}) };
    })
    .filter(Boolean);
  // Item 24: the same dimension may be assigned to several table columns — query it once and let
  // the client clone the duplicate instances (alias + clone_of).
  const seenDim = new Set();
  const uniqueDimensions = dimensions.filter((d) => {
    const k = d.alias || d.key || (d.date_part ? `${d.field}_${d.date_part}` : d.field);
    if (!k) return true;
    if (seenDim.has(k)) return false;
    seenDim.add(k);
    return true;
  });
  const measures = [];      // governed measure keys
  const measure_labels = {}; // per-visual label overrides for governed keys
  const adhoc_measures = []; // ad-hoc {field, agg, alias}
  (config.measures || []).forEach((m) => {
    if (!m) return;
    if (m.key) {
      measures.push(m.key);
      if (m.label) measure_labels[m.key] = m.label;
    }
    else if (m.field) adhoc_measures.push({ field: m.field, agg: m.agg || "sum", alias: m.alias || null, label: m.label || null });
  });
  (config.tooltip_measures || []).forEach((t) => {
    if (t.field && t.agg) adhoc_measures.push({ field: t.field, agg: t.agg, alias: `tt_${t.agg}_${t.field}` });
  });

  const filters = [...(config.filters || []), ...(globalFilters || [])]
    .filter((f) => f.value != null && f.value !== "" && !(Array.isArray(f.value) && f.value.length === 0))
    .map((f) => ({
      key: f.key || null,
      field: f.field || null,
      op: f.op || "in",
      value: f.value,
      ...(f.date_part && f.date_part !== "none" ? { date_part: f.date_part } : {}),
    }));

  let sort = (config.sort || []).map((s) => ({ key: s.key || s.field, direction: s.direction || "desc" }));
  let limit = config.limit || 1000;
  const tn = config.topN;
  if (tn && Number(tn.n) > 0) {
    const m0 = (config.measures || [])[0];
    const mKey = m0 ? (m0.key || m0.alias || `${m0.agg || "sum"}_${m0.field}`) : null;
    if (mKey) {
      sort = [{ key: mKey, direction: tn.direction === "asc" ? "asc" : "desc" }];
      limit = Number(tn.n);
    }
  }

  return {
    dimensions: uniqueDimensions,
    measures,
    adhoc_measures,
    filters,
    sort,
    limit,
    ...(Object.keys(measure_labels).length ? { measure_labels } : {}),
    ...(post_bands.length ? { post_bands } : {}),
  };
}
